module.exports = __webpack_public_path__ + "img/Cloud-Moon.675a7cdd.svg";